module.exports = __webpack_public_path__ + "img/restaurant.e7c01a8b.jpg";